import { useTranslation } from "react-i18next";

import { Typography } from "@digital-services/ui";

import { useOrganizationContext } from "@organization/context/useOrganizationContext";

import { formatterShort } from "@utils/time-utils";

import { OrganizationStatusIcon } from "./status/OrganizationStatusIcon";

const OrganizationInfo = () => {
  const { organization } = useOrganizationContext();
  const { t } = useTranslation(undefined, { keyPrefix: "organization" });

  return (
    <div
      className="organization-short-description"
      data-testid="organization-short-description"
    >
      <Typography
        variant="description"
        className="mb-5 flex items-center gap-2"
      >
        <OrganizationStatusIcon status={organization?.status} />
        <span>|</span>
        <span>{t("created-on.prefix")}</span>
        <span>{formatterShort(organization.createdOn)}</span>
      </Typography>
    </div>
  );
};

export default OrganizationInfo;
